import { SemaphoreDemo } from "../../ui/SemaphoreDemo";

interface SemaphoreProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Flash cards",
    blurb: "See a semaphore pose, name the letter. Tracks your hit-rate per character.",
    ready: true,
  },
  {
    slug: "numerals",
    name: "Numerals",
    blurb: "Numbers in semaphore: a “numbers follow” prefix pose, then digits 0–9 mapped to letter poses A–I, K. Tap the digit.",
    ready: true,
  },
  {
    slug: "translate",
    name: "Translate",
    blurb: "Type a message, watch the signaller cycle through each pose. Hide the text to make a sign for someone else to decode.",
    ready: true,
  },
];

export function Semaphore({ onNavigate }: SemaphoreProps) {
  return (
    <>
      <h2>Demo</h2>
      <SemaphoreDemo />

      <h2 style={{ marginTop: 32 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>
            {g.name}
            {!g.ready && (
              <span className="pill" style={{ marginLeft: 8, fontSize: 12 }}>
                coming soon
              </span>
            )}
          </h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          {g.ready ? (
            <button
              onClick={() => onNavigate(`/play/semaphore/${g.slug}`)}
              className="secondary"
            >
              Play
            </button>
          ) : (
            <button disabled className="secondary">
              Not yet
            </button>
          )}
        </div>
      ))}
    </>
  );
}
